// Importa o componente
import component from './bTable.vue';

// Declara a função de instalação executada pelo Vue.use()
export function install(Vue) {
  if (install.installed) return;
  install.installed = true;
  Vue.component('bTable', component);
}

// Cria a definição do módulo para Vue.use()
const plugin = {
  install,
};

// Para permitir o uso como um módulo exportável (npm/webpack/etc.)
export default component;
